import { useActive, useCommands } from '@remirror/react-core';
import { UnderlineOutlined } from '@ant-design/icons';
import CommandButton from '../CommandButton';
import React, { useCallback } from 'react';

export const UnderlineButton = React.memo(() => {
  const { toggleUnderline } = useCommands();

  const handleSelect = useCallback(() => {
    if (toggleUnderline.enabled()) {
      toggleUnderline();
    }
  }, [toggleUnderline]);

  const active = useActive().underline();
  const enabled = toggleUnderline.enabled();

  return (
    <CommandButton
      aria-label={'Underline'}
      icon={<UnderlineOutlined />}
      active={active}
      enabled={enabled}
      onClick={handleSelect}
    />
  );
});

export default UnderlineButton;
